import type { FrontendOnlyPieces } from '../../hooks/useSettings/WebsiteSettings';
import { AxisFooter } from './Footer';

// Axis Insurance — frontend-only pieces; all data fields live on the backend
export const frontendPieces: FrontendOnlyPieces = {
  slug: 'axisinsurance',
  Footer: AxisFooter,
};
